// TSS vite/02 — limits of the number store surface.

// 10.000 tiles cannot all be in the DOM at once; the grid pages through them.
export const STORE_PAGE_SIZE = 120;

export const MAX_CART_SIZE = 20;

export const QUICK_PICK_COUNT = 5;

// A query is a digit prefix: 4 digits identifies exactly one number.
export const MAX_QUERY_LENGTH = 4;

export const STORE_PARAMS = {
    QUERY: 'q',
    PAGE:  'p',
};

export const NUMBER_STATES = {
    FREE: 'free',
    SOLD: 'sold',
    MINE: 'mine',
};
